import { useTranslation } from "react-i18next";

import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import { getFullDate, getTime } from "utils";

type UseLocalTimeTooltipParams = {
  date: Date;
  withSeconds?: boolean;
};

export function useLocalTimeTooltip({
  date,
  withSeconds,
}: UseLocalTimeTooltipParams) {
  const { t } = useTranslation("common");
  const fullDate = getFullDate(date);
  const hours = getTime(date, withSeconds);
  const title = t(COMMON_TRANSLATION_KEYS.thisTimestampInUTC, {
    fullDate,
    hours,
  });

  return { title };
}
